const { getElement } = window.BAO.Utils

/**
 * @class BaoProductDeal
 * @extends {window.BAO.CustomElement()}
 */
class BaoAppProductDeal extends window.BAO.CustomElement() {
  static #SECTION_ID = 'push-cart-items'
  static #CART_STATE_ELEMENT_SELECTOR = '[data-cart-state-el]'

  setupListeners () {
    super.setupListeners()

    if (this.dataset.isProductPage !== 'true') return

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.SECTION_RENDERER.AFTER_RENDER,
      this.handleAfterRender.bind(this),
    )
  }

  handleAfterRender (event) {
    if (event?.detail?.section?.id !== BaoAppProductDeal.#SECTION_ID) return

    const productEls = this.els?.product?.elements ?? []
    productEls.forEach(productEl => {
      const cartHasProduct = this.cartState.items.find(
        item => item.product_id === Number(productEl.dataset?.productId ?? 0),
      )

      productEl.setAttribute('data-is-in-cart', Boolean(cartHasProduct))
    })
  }

  /**
   * @returns {Object} The current cart state
   *
   * @readonly
   */
  get cartState () {
    const cartStateEl = getElement(
      BaoAppProductDeal.#CART_STATE_ELEMENT_SELECTOR,
    )

    if (!cartStateEl) return {}

    return JSON.parse(cartStateEl.textContent ?? '{}')
  }
}

if (!window.customElements.get('bao-app-product-deal')) {
  window.customElements.define('bao-app-product-deal', BaoAppProductDeal)
}
